import React, { Component, useState } from "react";
import { render } from "react-dom";
import AdminBases from "./AdminBasesMobile";
import AdminBasesD from "./AdminBasesDesktop";
import { useMediaQuery } from 'react-responsive'


export default function AdminBasesResponsive(){
    const isMobileDevice = useMediaQuery({
        query: "(max-width: 48em)",
      });

  return(
      <div>
        {!isMobileDevice && <AdminBasesD/>}
        {isMobileDevice && <AdminBasesD/>}  
      </div>
    )
}

